import {useMotionValue, MotionValue} from 'motion/react';

export const useScrollState = (scrollProgress?: MotionValue<number>) => {
    const isStatic = !scrollProgress;
    const staticMotionValue = useMotionValue(0);

    return {
        isStatic,
        staticMotionValue,
        effectiveScrollProgress: scrollProgress || staticMotionValue,
    };
};
